import React from 'react';
import PropTypes from 'prop-types';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { withRouter } from 'react-router-dom';
import {
  Button,
} from '@material-ui/core';

/**
 * This component allows to render a button with the specific go backaction.
 * @param {*} param0
 */
const GoBackButton = ({
  history: { goBack }, className, style, label = 'Atrás', ...rest
}) => (
  <Button
    className={className}
    style={{
      ...style,
      marginRight: 15,
    }}
    variant="contained"
    onClick={() => goBack()}
    startIcon={<ArrowBackIcon />}
    {...rest}
  >
    {label}
  </Button>
);

GoBackButton.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
  style: PropTypes.shape(),
};

GoBackButton.defaultProps = {
  className: '',
  style: {},
};

export default withRouter(GoBackButton);
